import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface SummaryProps {
    firstShotTime: string;
    lastShotTime: string;
    currentDay: string;
    scriptLines?: any[];
    totalPlannedScriptLines: number;
    plannedScriptLines: Record<string, number>;
    coveredScriptLines: Record<string, number>;
    callSheetRawData?: any;
    actionDurationsPerScene?: any;
}

export function Summary (props: SummaryProps) {
  const { actionDurationsPerScene ,firstShotTime, lastShotTime, currentDay, plannedScriptLines, coveredScriptLines, totalPlannedScriptLines, callSheetRawData } = props;

  const scenesForSelectedDay = currentDay === 'All Days'
    ? Object.keys(plannedScriptLines || {})
    : callSheetRawData
      ?.filter((item: any) => item.Day.toString() === currentDay)
      .map((item: any) => item.Sequence.toString()) || [];

  const sceneNumbersToDisplay = Object.keys(plannedScriptLines || {})
    .filter(sceneNumber => scenesForSelectedDay.includes(sceneNumber));
  return (
    <Grid container>
        <Grid item xs={12}>
            <TableContainer component={Paper}>
                <Table size="small" sx={{ tableLayout: 'fixed' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Scene</TableCell>
                            <TableCell>Planned Script Lines</TableCell>
                            <TableCell>Covered Script Lines</TableCell>
                            <TableCell>Camera Time (seconds)</TableCell>
                            <TableCell>Action Time (seconds)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sceneNumbersToDisplay.map((sceneNumber: string) => {
                          const planned = plannedScriptLines[sceneNumber] || 0;
                          const covered = coveredScriptLines?.[sceneNumber] || 0;
                          const diff = Math.abs(planned - covered);
                          const percentage = planned > 0 ? (covered / planned) : 0;

                          let rowColor = 'inherit';
                          if (planned > 0 && percentage > 0.9) {
                            rowColor = '#66BB6A'; // Green
                          } else if (diff > 5) {
                            rowColor = 'inherit'; // Red
                          }

                          return (
                            <TableRow key={sceneNumber} sx={{ backgroundColor: rowColor }}>
                                <TableCell component="th" scope="row">
                                    {sceneNumber}
                                </TableCell>
                                <TableCell>{plannedScriptLines[sceneNumber]}</TableCell>
                                <TableCell>{coveredScriptLines?.[sceneNumber] || 0}</TableCell>
                                <TableCell>{Math.trunc(actionDurationsPerScene?.[sceneNumber]?.totalActionDuration || 0)}</TableCell>
                                <TableCell>{Math.trunc(actionDurationsPerScene?.[sceneNumber]?.maxActionDuration || 0)}</TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    </Grid>
  );
}
